import React, { Suspense, lazy } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import DashboardPage from "./dashboard/DashboardPage";
import { LayoutSplashScreen } from "../../../_metronic";

const AdminPage = lazy(() => import("./admin/AdminPage"));
const GrupoPage = lazy(() => import("./grupo/GrupoPage"));
const ContratoPage = lazy(() => import("./contrato/ContratoPage"));
const ProdutoPage = lazy(() => import("./produto/ProdutoPage"));

export default function HomePage() {
    return (
        <Suspense fallback={<LayoutSplashScreen />}>
            <Switch>
                <Redirect exact from="/" to="/dashboard" />

                <Route path="/dashboard" component={DashboardPage} />
                <Route path="/admin" component={AdminPage} />
                <Route path="/grupo" component={GrupoPage} />
                <Route path="/contrato" component={ContratoPage} />
                <Route path="/produto" component={ProdutoPage} />

                <Redirect to="/error/error-v6" />
            </Switch>
        </Suspense>
    );
}
